import { render, staticRenderFns } from "./Limit4Type.vue?vue&type=template&id=1cb61ef6&scoped=true&"
import script from "./Limit4Type.vue?vue&type=script&lang=js&"
export * from "./Limit4Type.vue?vue&type=script&lang=js&"
import style0 from "./Limit4Type.vue?vue&type=style&index=0&id=1cb61ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb61ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
